// Utility shared across the SPA to detect when we are running on a local/dev
// hostname. This is used to ensure local dev uses SPA-managed auth routes and
// avoids redirecting to deployed endpoints.
// localhost, 127.0.0.1 and common private IP ranges.
// IMPORTANT: Auth0 (Authorization Extension / rules) cannot call a private address.
// This detection is about where the browser is running (the SPA), not where
// backend services live.
export default function isLocalHostname(hostname) {
  return /^(localhost|127\.0\.0\.1|10\.|192\.168\.|172\.(1[6-9]|2\d|3[0-1])\.)/.test(
    hostname
  );
}
